export const isValidE164Format = (phoneNumber: string): boolean =>
  /^(\+?\d{1,3} ?)?(\d{1,4} ?){2,4}$/.test(phoneNumber);
